import { Star, X } from 'lucide-react';
import { useTravellerFeedback } from '../../../../../../context/travellerFeedback/TravellerFeedbackContext';
import { formatFeedbackDate, formatBookingId } from '../../../../utils/feedbackHelpers';

const FeedbackModal = () => {
  const { selectedFeedback, setSelectedFeedback } = useTravellerFeedback();

  if (!selectedFeedback) return null;

  const bookingIdFormatted = formatBookingId(selectedFeedback.booking_id);

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6 shadow-xl border border-slate-100">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-gray-900">Feedback Details</h3>
          <button
            onClick={() => setSelectedFeedback(null)}
            className="p-1 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
            aria-label="Close modal"
          >
            <X size={20} />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Customer Info</h4>
            <div className="space-y-2 text-sm text-gray-600">
              <p>
                <span className="text-gray-400 w-20 inline-block">Name:</span>{' '}
                <span className="font-medium text-slate-800">{selectedFeedback.user_name || 'Anonymous'}</span>
              </p>
              <p>
                <span className="text-gray-400 w-20 inline-block">Booking:</span>{' '}
                <span className="font-mono text-slate-800 font-bold lowercase">{bookingIdFormatted || 'N/A'}</span>
              </p>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Feedback Info</h4>
            <div className="space-y-2 text-sm text-gray-600">
              <div className="flex items-center">
                <span className="text-gray-400 w-20 inline-block">Rating:</span>
                <div className="flex items-center gap-1 font-semibold text-amber-500">
                  <Star size={14} className="fill-amber-400 text-amber-400" />
                  <span>{selectedFeedback.rating}/5</span>
                </div>
              </div>
              <p>
                <span className="text-gray-400 w-20 inline-block">Type:</span>{' '}
                <span className="text-slate-800 font-medium">{selectedFeedback.feedback_type || 'General'}</span>
              </p>
              <p>
                <span className="text-gray-400 w-20 inline-block">Date:</span>{' '}
                <span className="text-slate-800">{formatFeedbackDate(selectedFeedback.createdAt)}</span>
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 rounded-xl p-4 mb-6 border border-slate-100">
          <h4 className="text-sm font-semibold text-gray-900 mb-2">Message</h4>
          <p className="text-gray-700 text-sm leading-relaxed">{selectedFeedback.feedback_text}</p>
        </div>

        {selectedFeedback.agent_response && (
          <div className="bg-teal-50 rounded-xl p-4 mb-4 border border-teal-100">
            <h4 className="text-sm font-semibold text-[#067978] mb-2">Your Response</h4>
            <p className="text-teal-900 text-sm">{selectedFeedback.agent_response.text}</p>
            <div className="text-xs text-teal-600 mt-2">
              Replied on {formatFeedbackDate(selectedFeedback.agent_response.responded_at)}
            </div>
          </div>
        )}

        <div className="flex justify-end pt-4 border-t border-gray-100">
          <button
            onClick={() => setSelectedFeedback(null)}
            className="px-6 py-2.5 bg-gray-100 text-gray-700 font-medium rounded-xl hover:bg-gray-200 transition-colors cursor-pointer text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
